import { render } from "./B2bPageProfileParties.vue?vue&type=template&id=57beb03f&scoped=true&lang=pug"
import script from "./B2bPageProfileParties.vue?vue&type=script&lang=js"
export * from "./B2bPageProfileParties.vue?vue&type=script&lang=js"

import "./B2bPageProfileParties.vue?vue&type=style&index=0&id=57beb03f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57beb03f"]])

export default __exports__